/**
 * Shared Basket Feature — user-facing message strings.
 */

// Share link expiration (in days)
export const SHARE_LINK_EXPIRY_DAYS = 30;

// Navigation delay after successful operations (in ms)
export const NAVIGATION_DELAY_MS = 1000;

// Error messages
export const SHARE_ERROR_MESSAGES = {
  NO_CART: 'Your basket is empty. Add items before sharing.',
  CREATE_LINK_FAILED: 'Unable to create share link. Please try again.',
  SEND_EMAIL_FAILED: "Unable to send email. Please check the recipient's email address.",
  INVALID_EMAIL: 'Please enter a valid email address.',
  NETWORK_ERROR: 'Network error. Please check your connection and try again.',
  GENERIC_ERROR: 'Failed to share basket. Please try again.',
  CONFIG_ERROR: 'Configuration error. Please contact support.',
  EXPIRED_LINK: 'This share link has expired',
  LINK_NOT_FOUND: 'Share link not found',
  PRODUCTS_UNAVAILABLE: 'The products in this basket are no longer available',
  ADD_TO_CART_FAILED: 'Failed to add items to cart. Please try again.',
  NO_VALID_ITEMS: 'No valid items to add to cart',
} as const;

// Success messages
export const SHARE_SUCCESS_MESSAGES = {
  BASKET_SHARED: 'Basket shared successfully!',
  BASKET_SHARED_MODAL_TITLE: 'Basket shared!',
  BASKET_SHARED_MODAL_MESSAGE: (recipientName: string): string =>
    `We've shared your basket with ${recipientName}`,
  BASKET_UPDATED: 'Your basket has been updated',
  ITEM_ADDED_TITLE: 'Item added to basket',
  ITEM_ADDED_MESSAGE: (productName: string): string =>
    `${productName} has been added to basket.`,
  ITEMS_ADDED: 'Items added to basket',
  ITEMS_ADDED_DESC:
    'The shared items have been added to your basket with current prices.',
} as const;

// Warning messages
export const SHARE_WARNING_MESSAGES = {
  SOME_PRODUCTS_MISSING: (count: number): string =>
    `${count} item(s) are no longer available and will be skipped`,
  CUSTOMER_GROUPS_FAILED:
    'Could not load pricing information. Default prices will be used.',
} as const;
